//  Show more on news archive
var showMore = document.querySelector('.blog-sidebar .show-more')
var archive = document.querySelector('.blog-sidebar')

if (archive){
  showMore.addEventListener('click', function() {
    archive.classList.toggle('active')
    showMore.classList.toggle('active')
  });
}